import { CRBTUICSSStyle, CRBTUICSSStyleImpl } from '../crbt/crbtuicss';

export interface GroupCSSStyle extends CRBTUICSSStyle
{
   
}

export class GroupCSSStyleImpl extends CRBTUICSSStyleImpl implements GroupCSSStyle
{
   
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/groups/groupcss.tsx